import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const Protected = ({
  children
}: { children: JSX.Element }) => {
  let location = useLocation();

  const { getToken } = useAuth()

  const user = getToken()

  if(!Boolean(user)){
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return children
};

export default Protected;
